/**
 * Session 31 · GA4 + Google Ads Loader (idempotent, testmode-aware).
 *
 * Regeln:
 *  - GA4 nur nach Analytics-Consent, Google Ads nur nach Marketing-Consent.
 *  - Consent Mode v2 wurde bereits **vor** diesem Loader initialisiert.
 *  - Bei TEST_MODE keine echten Netzwerkanfragen.
 */

const GA_SCRIPT_ID = "pb24-gtag-script";

let _gtagScriptLoaded = false;
let _ga4Configured = false;
let _adsConfigured = false;
let _measurementId = null;
let _adsConversionId = null;
let _testMode = true;

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
  }
}

function loadGtagScript(anchorId) {
  if (_gtagScriptLoaded) return;
  ensureGtagStub();

  // gtag('js', new Date()) einmalig
  try { window.gtag("js", new Date()); } catch (_) { /* noop */ }

  if (!document.getElementById(GA_SCRIPT_ID) && !_testMode && anchorId) {
    const s = document.createElement("script");
    s.id = GA_SCRIPT_ID;
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(anchorId)}`;
    document.head.appendChild(s);
  }
  _gtagScriptLoaded = true;
}

export function initGA4({ measurementId, testMode }) {
  if (_ga4Configured) return true;
  if (!measurementId) return false;
  _measurementId = measurementId;
  _testMode = !!testMode;

  loadGtagScript(measurementId);
  try {
    // anonymize_ip + send_page_view=true (Standard). SPA-Dedup passiert im dispatcher.
    window.gtag("config", measurementId, {
      anonymize_ip: true,
      send_page_view: false, // wir feuern PageView zentral im dispatcher (SPA-safe)
    });
  } catch (_) { /* noop */ }

  _ga4Configured = true;
  return true;
}

export function initGoogleAds({ conversionId, testMode }) {
  if (_adsConfigured) return true;
  if (!conversionId) return false;
  _adsConversionId = conversionId;
  _testMode = _testMode || !!testMode;

  loadGtagScript(conversionId);
  try {
    window.gtag("config", conversionId);
  } catch (_) { /* noop */ }

  _adsConfigured = true;
  return true;
}

export function gtagEvent(eventName, params = {}) {
  if (_testMode) return;
  if (typeof window.gtag !== "function") return;
  try { window.gtag("event", eventName, params); } catch (_) { /* noop */ }
}

export function isGA4Initialized() { return _ga4Configured; }
export function isGoogleAdsInitialized() { return _adsConfigured; }

/** Consent-Widerruf: künftig keine Events mehr. */
export function disableGoogleTracking() {
  _ga4Configured = false;
  _adsConfigured = false;
}
